import * as z from "zod";
import { ensureWritable, modifyStepConfig } from "../copyOnWrite";
import { ROUTE_TYPES } from "../stepConfig";
import { mutator } from "./mutator";
import { branchSchema } from "./utils";

export const updateStepRouteType = mutator({
  schema: z
    .object({
      stepDir: z.string(),
      routeType: z.enum(ROUTE_TYPES),
    })
    .merge(branchSchema),
  resolve: {
    branch: { kind: "branch", from: "branchId" },
  },
  permissions: [
    {
      permission: "space:write",
      scopeId: ({ args }) => args.branch.workflow.spaceId,
    },
  ],
  fn: async ({ tx, ctx, args }) => {
    const {
      stepDir,
      routeType,
      branch,
      forkBranchId,
      forkCommitId,
      forkChatId,
      workingCommitId,
      workingChatId,
    } = args;
    const { commitId } = await ensureWritable(
      tx,
      ctx,
      ctx.tenantId,
      {
        branchId: branch.id,
        forkBranchId,
        forkCommitId,
        forkChatId,
        workingCommitId,
        workingChatId,
      },
      branch
    );
    await modifyStepConfig(tx, commitId, ctx.tenantId, stepDir, { routeType });
  },
});
